import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { isFalsy, isTruthy } from 'lib/Helpers';
import { doesStringInclude } from 'lib/Formatting';
import * as styles from './ProgressBar.scss';

/**
 * @class ProgressBar
 * @classdesc Global API Call ProgressBar Component
 * @property {Object} state
 * @property {(Function | null)} interval
 */
class ProgressBar extends Component {
  static propTypes = {
    pendingTasks: PropTypes.number.isRequired,
    showing: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      autoIncrement: true,
      intervalTime: 50,
      isProduction: false,
      percent: 0,
      progressIncrease: 30,
    };
    this.interval = null;
  }

  componentDidMount() {
    const isProduction = doesStringInclude(window.location.href, 'cloud.bridg.com');
    this.setCurrentEnvironment(isProduction);
    return this.handleIncrementInterval(isProduction);
  }

  componentWillUnmount() {
    if (this.interval) return clearInterval(this.interval);
    return null;
  }

  /**
   * Initializes the Interval of Incrementation of the ProgressBar
   * @param {boolean} isProduction
   * @return {(Function|null)}
   */
  handleIncrementInterval = isProduction => {
    const { autoIncrement, intervalTime } = this.state;
    /* Do Not Initialize Interval if in Production */
    if (isTruthy(isProduction) || isFalsy(autoIncrement)) return null;

    this.interval = setInterval(this.handleIncrement, intervalTime);
    return this.interval;
  }

  /**
   * Updates the Current Percentage in State
   * @return {Function} this.setState
   */
  handleIncrement = () => {
    const { showing } = this.props;
    const { percent } = this.state;

    if (!showing && percent !== 0) return this.setState({ percent: 0 });
    else if (!showing) return null;
    return this.setState({ percent: this.calcPercentage(percent) });
  }

  /**
   * Calculates the Current Percentage for ProgressBar Width
   * @param {number} percent
   * @return {number}
   */
  calcPercentage = percent => {
    const { pendingTasks } = this.props;
    const { progressIncrease } = this.state;

    return percent >= 99
      ? 99
      : percent + (progressIncrease / pendingTasks);
  }

  /**
   * Sets isProduction Flag in State
   * @param {boolean} isProduction
   * @return {Function} this.setState
   */
  setCurrentEnvironment = isProduction => {
    /* Needs to be Altered if Production Location Changes */
    return this.setState({ isProduction });
  }

  render() {
    const { showing } = this.props;
    const { isProduction, percent } = this.state;

    if (isFalsy(showing)) return null;
    /* ProgressBar to be Disabled in Production Environments */
    else if (isTruthy(isProduction)) return null;
    return (
      <div className={styles.progressBar}>
        <div className={styles.progress} style={{ width: `${percent}%` }} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  pendingTasks: state.axios.pendingTasks,
  showing: state.progressBar.showing,
});

const ConnectedProgressBar = connect(mapStateToProps)(ProgressBar);

export { ProgressBar as PureProgressBar };
export default ConnectedProgressBar;
